var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m24.452 28.264.818-.822a4.86 4.86 0 0 0 3.802-1.418 4.917 4.917 0 0 0-.002-6.931 4.866 4.866 0 0 0-6.902 0 4.9 4.9 0 0 0-1.413 3.816l-.96.963.607.61-4.685 4.704.044 3.27 3.256.044.427-.428-.299-1.116 1.111.3.805-.808-.297-1.116 1.11.299.806-.808-.3-1.116 1.114.3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M27.606 22.31a1.226 1.226 0 0 1-1.74 0 1.24 1.24 0 0 1 0-1.747 1.23 1.23 0 0 1 1.74 0 1.24 1.24 0 0 1 0 1.747M21.414 25.382l-1.042-1.045M25.98 14.235a2.465 2.465 0 0 1-2.46 2.471H11.96a2.466 2.466 0 0 1-2.46-2.47v-3.883a2.466 2.466 0 0 1 2.46-2.47h11.56a2.465 2.465 0 0 1 2.46 2.47z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.79 13.477a1.11 1.11 0 0 1-1.106-1.113c0-.614.496-1.111 1.107-1.111"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M26.81 21.06c1.358 0 2.466-1.07 2.466-2.437v-3.787c0-1.365-.988-2.542-2.346-2.542h-3.697M16.092 13.477c0 .617-.588 1.023-1.202 1.023h-.755c-.616 0-1.34-.406-1.34-1.023v-2.52c0-.617.518-.869 1.134-.869h1.099c.613 0 1.064.252 1.064.869zM18.274 9.602c.616 0 1.114.738 1.114 1.355v2.991M17.74 14.5h3.296"
}))));
export default SvgCheckin;